<template>
  <el-date-picker unlink-panels  :size="size" v-model="selectdate" :format="format" :value-format="format" :type="type" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions0" :style="{'width':width}" @change="change"></el-date-picker>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '300px'
    },
    format:{
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    type:{
      type: String,
      default: 'datetimerange'
    },
    size:{
      type: String,
      default: 'mini'
    },

  },
  data() {
    return {
      selectdate:[],
      pickerOptions0:{
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              //console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },

          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去14天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        // disabledDate(time) {
        //   return time.getTime() > new Date(new Date().setTime(new Date().getTime() + 3600 * 1000 * 24 * 1))
        // }
      }
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
      change(v){
        this.$emit("change",v)
      }
  }
}
</script>
